import store from '@/store'
const base = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '') + '/oa/admin/file-center'
export async function fileRequest(path, data, method = 'GET', binary = false) {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), binary ? 300000 : 30000)
  try {
  const response = await fetch(base + path, {
    method, headers: { Authorization: 'Bearer ' + store.state.token, 'Win-Type': '3', 'Content-Type': 'application/json' },
    body: method === 'GET' ? undefined : JSON.stringify(data || {}), cache: 'no-store', signal: controller.signal
  })
  if (binary && response.ok && !(response.headers.get('content-type') || '').includes('json')) return await response.blob()
  let body
  try { body = await response.json() } catch (_) { throw new Error('文件服务响应异常') }
  if (!response.ok || body.code !== 0) throw new Error(body.message || '无权限或请求失败')
  return body.data
  } catch (e) {
    if (e.name === 'AbortError') throw new Error('请求超时，请刷新确认结果后再操作')
    throw e
  } finally { clearTimeout(timeout) }
}
export function saveBlob(blob, name) {
  const url = URL.createObjectURL(blob), a = document.createElement('a')
  a.href = url; a.download = name; a.click(); setTimeout(() => URL.revokeObjectURL(url), 30000)
}
export function fileIcon(a) {
  return {doc:['W','#2874cf'],docx:['W','#2874cf'],xls:['X','#218358'],xlsx:['X','#218358'],ppt:['P','#d66036'],pptx:['P','#d66036'],pdf:['PDF','#d94343']}[a.extension] ||
    {IMAGE:['图','#7b60c6'],VIDEO:['▶','#4668b2'],VOICE:['音','#548f92']}[a.fileKind] || ['FILE','#73849b']
}
export function fileSize(n) { return n < 1048576 ? (n / 1024).toFixed(1) + ' KB' : (n / 1048576).toFixed(1) + ' MB' }
